import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { access } from "fs";

@Injectable({
    providedIn: "root"
})
export class LearnerService {

    baseUrl = environment.url;
    mySessionsUrl = "lnd/my-sessions/";
    upcomingSessionsUrl = "lnd/upcoming-sessions/";
    pastSessionsUrl = "lnd/past-sessions/";
    getSessionUrl = "lnd/sessions/";
    userTypeUrl = "lnd/user-type/";
    private readonly presignedUrlEndpoint = "lnd/presigned-url/";
    getHolidayListUrl ="appraisal/all_holidays/";  
    getDocumentsListUrl:string ='';  
    festivalThemeUrl = "appraisal/festival/theme/";
    getEmployeeDetailsURL='appraisal/employee/';
    constructor(
        private http: HttpClient
    ) {
        console.log("learner service obj created");
    }
    
    //method to get access token for header
    private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('accessToken') || '';
     return new HttpHeaders().set('Authorization', token);
    }

    // Method to fetch festival theme from API
    fetchFestivalTheme() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.festivalThemeUrl, { headers });
    }

    getUserType() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.userTypeUrl, { headers });
    }

    getHolidayList() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.getHolidayListUrl, { headers });
    }
    
    getMySessions() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.mySessionsUrl, { headers });
    }

    getUpcomingSessions() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.upcomingSessionsUrl, { headers });
    }

    getPastSessions() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.pastSessionsUrl, { headers });
    }

    getSession() {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.getSessionUrl, { headers });
    }

    enroll(id, body) {
        const headers = this.getAuthHeaders();
        return this.http.post(this.baseUrl + this.getSessionUrl + id + '/enrollment/', body, { headers });
    }

    unenroll(id, body) {
        const headers = this.getAuthHeaders();
        return this.http.put(this.baseUrl + this.getSessionUrl + id + '/enrollment/', body, { headers });
    }

    myFeedback(id, body) {
        const headers = this.getAuthHeaders();
        return this.http.post(this.baseUrl + this.getSessionUrl + id + '/my-feedback/', body, { headers });
    }

    getMyFeedback(id) {
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.getSessionUrl + id + '/my-feedback/', { headers });
    }

    getDocumentsList(type:any) {
        this.getDocumentsListUrl =`appraisal/api/documents/?type=${type}`
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.getDocumentsListUrl, { headers });
    }

    getDocumentBase64(file: string) {
        const headers = this.getAuthHeaders();
        const params = new HttpParams().set('file_url', file);
        return this.http.get(this.baseUrl + this.presignedUrlEndpoint, {
            headers,
            params,
            responseType: 'arraybuffer'
        });
    }

    getEmployeeDetails(){
        const headers = this.getAuthHeaders();
        return this.http.get(this.baseUrl + this.getEmployeeDetailsURL, { headers });
    }
   
}

